import React from 'react'
import VerifySignInWidget from './verify_sign_in_widget'


function VerifySignIn() {
  return (
    <div>
        <VerifySignInWidget/>
    </div>
  )
}

export default VerifySignIn